import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/model
 */
import { ObservableMixin } from '@ckeditor/ckeditor5-utils';
import { extend } from 'lodash-es';
/**
 * The base MVC model class.
 */
var Model = /*#__PURE__*/function (_ObservableMixin) {
  _inherits(Model, _ObservableMixin);
  var _super = _createSuper(Model);
  /**
   * Creates a new Model instance.
   *
   * @param attributes The model state attributes to be defined during the instance creation.
   * @param properties The (out of state) properties to be appended to the instance during creation.
   */
  function Model(attributes, properties) {
    var _this;
    _classCallCheck(this, Model);
    _this = _super.call(this);
    // Extend this instance with the additional (out of state) properties.
    if (properties) {
      extend(_assertThisInitialized(_this), properties);
    }
    // Initialize the attributes.
    if (attributes) {
      _this.set(attributes);
    }
    return _this;
  }
  return Model;
}(ObservableMixin());
export { Model as default };